module.exports = __webpack_public_path__ + "static/media/bag.fedae7e3.jpg";